import * as React from 'react';

export interface IClickOutsideProps {
  onOutside(): void;
  capture?: boolean;
  children?: React.ReactNode;
}

export class ClickOutside extends React.Component<IClickOutsideProps> {
  public static defaultProps: Partial<IClickOutsideProps> = {
    capture: true,
  };

  private node: HTMLElement;
  private handleOutsideClick = (e: MouseEvent) => {
    if (e.target && this.findParent(this.node, e.target as HTMLElement)) {
      return;
    }
    this.props.onOutside();
  };

  public componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick, { capture: this.props.capture });
  }

  public componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, { capture: this.props.capture });
  }

  public render() {
    return (
      <div
        ref={node => {
          return node && (this.node = node);
        }}
      >
        {this.props.children}
      </div>
    );
  }

  private findParent(rootElement: HTMLElement, element: HTMLElement) {
    let copiedElement = element;
    while (copiedElement.parentElement) {
      copiedElement = copiedElement.parentElement;
      if (copiedElement === rootElement) {
        return copiedElement;
      }
    }

    return null;
  }
}
